import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "admin-view" }
const _hoisted_2 = { class: "content-grid" }

import { ref, onMounted } from 'vue'
import { api } from '@/composables/api'
import StatsGrid from '@/components/dashboard/StatsGrid.vue'
import ActivityList from '@/components/dashboard/ActivityList.vue'
import QuickActions from '@/components/dashboard/QuickActions.vue'


export default /*@__PURE__*/_defineComponent({
  __name: 'DashboardView',
  setup(__props) {

const loading = ref(true)
const stats = ref({
  totalRequests: 0,
  pendingRequests: 0,
  deliveredEquipment: 0,
  totalEquipment: 0
})

const recentRequests = ref<any[]>([])

const loadStats = async () => {
  try {
    // Load request stats
    const reqStats = await api.get('/requests/stats')
    if (reqStats.data) {
      stats.value.totalRequests = reqStats.data.total || 0
      stats.value.pendingRequests = reqStats.data.by_status?.pending || 0
    }

    // Load equipment stats
    const eqStats = await api.get('/equipment/stats')
    if (eqStats.data) {
      const available = eqStats.data.available || 0
      const processing = eqStats.data.processing || 0
      const troubleshooting = eqStats.data.troubleshooting || 0
      stats.value.totalEquipment = available + processing + troubleshooting
      stats.value.deliveredEquipment = eqStats.data.delivered || 0
    }
  } catch (error) {
    console.error('Error loading stats:', error)
  }
}

const loadRecentRequests = async () => {
  try {
    const response = await api.get('/requests?limit=5')
    if (response.data) {
      recentRequests.value = response.data.slice(0, 5)
    }
  } catch (error) {
    console.error('Error loading recent requests:', error)
  }
}

const refreshData = async () => {
  loading.value = true
  await Promise.all([loadStats(), loadRecentRequests()])
  loading.value = false
}

onMounted(async () => {
  await refreshData()
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[0] || (_cache[0] = _createElementVNode("div", { class: "page-header" }, [
      _createElementVNode("h1", null, "Admin Dashboard"),
      _createElementVNode("p", null, "System overview and administration")
    ], -1)),
    _createVNode(StatsGrid, { stats: stats.value }, null, 8, ["stats"]),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(ActivityList, {
        "recent-requests": recentRequests.value,
        loading: loading.value
      }, null, 8, ["recent-requests", "loading"]),
      _createVNode(QuickActions, { onRefresh: refreshData })
    ])
  ]))
}
}

})